import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { HeaderGroup } from '@tanstack/react-table';
import React from 'react';

import { THeaderItem } from './THeaderItem';

interface Props {
    headerGroup: HeaderGroup<any>;
    hideFilter?: boolean;
    sortingColumns?: string[];
    customDivClassName?: string;
    className?: string;
    tableId: string;
    dispatch: ThunkDispatch<any, any, Action>;
}

export function THeader(props: Props) {
    return (
        <tr key={props.headerGroup.id}>
            {props.headerGroup.headers.map((header, index) => (
                <THeaderItem
                    className={props.className}
                    customDivClassName={props.customDivClassName}
                    hideFilter={props.hideFilter}
                    key={header.id}
                    header={header}
                    sort={props.sortingColumns ? props.sortingColumns.includes(header.id) : false}
                    tableId={props.tableId}
                    dispatch={props.dispatch}
                />
            ))}
        </tr>
    );
}
